<template>
  <div class="app">
    <div class="top flex-xy">
    <div class="top1 flex-spc-x">

        <img style="height:40px" src="../assets/yyxb1.png" alt="" srcset="">

      <div class="cs">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1">申请使用</el-menu-item>
          <el-menu-item index="2">官网</el-menu-item>
          <!-- <el-menu-item index="3">周边</el-menu-item> -->
          <el-menu-item index="4">帮助</el-menu-item>
          <!-- <el-submenu index="2-4">
            <template slot="title">公众号</template>
            <img
              src="../assets/xb-qrcode.jpg"
              style="width: 100px;height:100px"
            />
          </el-submenu> -->
        </el-menu>
      </div>
    </div>
    </div>
    <div class="main">
      <img
        src="../assets/yxblogo.png"
        alt=""
        srcset=""
        style="
          width: 50%;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        "
      />
      <div class="right">
        <div class="flexc-cen-x1">
          <div v-if="active == 1" class="flex-xy" style="width: 100%;font-size:20px">
            <div>账号登录</div>
            <!-- <div class="border"></div> -->
          </div>
          
        </div>

        <div  class="input-l" style="margin-top:20px">
          <label class="label usernameaccount"></label>
          <div class="input-box">
            <input
              name="UserName"
              type="text"
              id="UserName"
              v-model="ruleForm.LoginName"
              size="12"
              maxlength="12"
              autocomplete="off"
              placeholder="请输入手机号"
              data-test="login-ename-username"
            />
          </div>
        </div>
        <div v class="input-l" style="margin-top:20px">
          <label class="label password"></label>
          <div class="input-box">
            <input
              name="UserPW"
              id="UserPW"
              v-model="ruleForm.Pwd"
              type="password"
              placeholder="请输入密码"
              data-test="login-ename-password"
            />
          </div>
        </div>
      <div class="input-l1">
            <el-checkbox class="remember" v-model="rememberpwd" style="margin-top:5px">记住密码</el-checkbox>
      </div>
     
        <!-- <div class="m-tips login-ename">
          <div class="tip-item" href="#">忘记密码？</div>
        </div> -->
        <!-- <div style="font-size: 14px; color: #409eff">暂无账号，立即注册</div> -->
        <div
          cursor
          class="loginBtn flex-xy cursor"
          @click="submitForm('ruleForm')"
          data-test="login-btn-phone"
        >
          登录
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="title">
         <div class="guan" style="width: 80%;font-size:20px">相关产品</div>
        <div class="guan" style="width: 20%;font-size:20px">咨询热线</div>
      </div>
      <div class="nei" style="margin-top: 20px">
        <div class="guan" style="width: 80%">
          <div class="flx"  @click="dozhyk"  style="cursor:pointer" >
            <img
              src="../assets/zhyk.png"
              alt=""
              srcset=""
              style="width: 45px; height: 45px"
            />
            <div style="margin-left: 10px">
              <div class="xiao">智火约课</div>
              <div style="font-size: 14px; float: left">智火约课</div>
            </div>
          </div>
          <div class="flx" style="margin-left: 100px;cursor:pointer"  @click="dozhtk" > 
            <img
              src="../assets/yyxb.png"
              alt=""
              srcset=""
              style="width: 72px; height: 44px"
            />
            <div style="margin-left: 10px">
              <div class="xiao">预约小宝</div>
              <div style="font-size: 14px; float: left">预约小宝</div>
            </div>
          </div>
          <div class="flx" style="margin-left: 100px;cursor:pointer" @click="doxbzj">
            <img
              src="../assets/xbzj.png"
              alt=""
              srcset=""
              style="width: 45px; height: 45px"
            />
            <div style="margin-left: 10px">
              <div class="xiao">锡宝助教</div>
              <div style="font-size: 14px; float: left">锡宝助教</div>
            </div>
          </div>
        </div>
        <div class="guan" style="width: 20%; font-size: 25px">400-112-7866</div>
      </div>

    </div>
        <el-dialog
        title="选择门店"
        :visible.sync="show"
        width="40%"
        >

      <el-radio-group v-model="radio"  >
        <el-radio v-for="items in list" :label="items" :key="items.StoresID" size="medium"  style="display:block;margin-top:15px"><span style="font-size:15px">{{items.StoresName}}</span></el-radio>
        
      </el-radio-group>

    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">取 消</el-button>
      <el-button type="primary" @click="toSure()">确 定</el-button>
  </span>
</el-dialog>
 <el-dialog
        title="提示"
        :visible.sync="showfalse"
        width="40%"
        >

  <div class="flex-xy">
    <el-result icon="error" :title="falseMsg" ></el-result>
  </div>
<!-- :subTitle="" -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="showfalse = false">取 消</el-button>
      <el-button type="primary" @click="showfalse = false">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
// import { getLogin } from "../api/api";
import { baseUrl } from "../config/env.js";
import { ajax } from "../config/fetch.js";
import { setCookie, getCookie, delCookie } from "../utils/util";
import md5 from "js-md5";
export default {
  name: "login",
  data() {
    return {
      radio: "",
      activeIndex: '1',
      active: '1',
      //定义loading默认为false
      logining: false,
      show: false,
      DianList: [],
      list: [],
      showfalse: false,
      falseMsg: "",
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //LoginName和password默认为空
        LoginName: "",
        Pwd: "",
        // code: '',
        // randomStr: '',
        // codeimg: ''
      },
      //rules前端验证
      rules: {
        LoginName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        Pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
      this.getuserpwd()
    // loading.close();
    // this.$nextTick(() => {
    //   loading.close();
    // });
    // this.$message({
    //   message: '账号密码及验证码不为空',
    //   type: 'success'
    // })
    // 获取图形验证码
    // this.getcode()
    // 获取存在本地的用户名密码
  
  },
  // 里面的函数只有调用才会执行
  methods: {
     dosq(){
       window.open("https://www.zhihuoyueke.com/regPC/sq.html")
      // window.location="http://wuxixiangdangdang.com/yueke.html";
     },dogw(){
              window.open("https://www.zhihuoyueke.com")
      },dobz(){
              window.open("https://www.zhihuoyueke.com/helpPC/index.html")
      },doxbzj(){
              window.open("http://wuxixiangdangdang.com")
      },dozhtk(){
              window.open("http://xingxingzhihuo.com.cn")
      },dozhyk(){
              window.open("https://www.zhihuoyueke.com")
      },

    handleSelect() {},
    choose() {
      this.active = 1;
    },
    choose2() {
      this.active = 2;
    },

    toSure() {
      var tokenurl = baseUrl + "/SelectLogin.aspx";
      var _parm = {
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        UserID: this.radio.UserID,
      };
      var that = this;
      ajax({
        url: tokenurl,
        type: "POST",
        contentType: "application/json;",
        data: JSON.stringify(_parm),
        success: function (res) {
          let _res = JSON.parse(res);
          if (_res.orsuccess == "1") {
            
                if(that.rememberpwd == true){
                      localStorage.setItem("user", that.ruleForm.LoginName);
                      localStorage.setItem("pwd", that.ruleForm.Pwd);
                    } else {
                        localStorage.removeItem("user")
                        localStorage.removeItem("pwd")
                    }

            localStorage.setItem("DueToTimeday", _res.DueToTimeday);
            localStorage.setItem("HeadUrl", _res.HeadUrl);
            localStorage.setItem("HeadUrllogo", _res.HeadUrllogo);
            localStorage.setItem("IsActivity", _res.IsActivity);
            localStorage.setItem("IsHeadOffice", _res.IsHeadOffice);
            localStorage.setItem("IsPay", _res.IsPay);
            localStorage.setItem("IsPublic", _res.IsPublic);
            localStorage.setItem("KendTime", _res.KendTime);
            localStorage.setItem("KstartTime", _res.KstartTime);
            localStorage.setItem("LoginID", _res.LoginID);
            localStorage.setItem("Name", _res.Name);
            localStorage.setItem("Sid", _res.Sid);
            localStorage.setItem("Storemodel", _res.Storemodel);
            localStorage.setItem("isCard", _res.isCard);
            localStorage.setItem("isGoods", _res.isGoods);
            localStorage.setItem("isCashier", _res.isCashier);
            localStorage.setItem("isProject", _res.isProject);
            localStorage.setItem("isXCX", _res.isXCX);
            localStorage.setItem("token", _res.token);
            localStorage.setItem("templateType", _res.templateType);
            localStorage.setItem("StoresID", _res.StoresID);
            localStorage.setItem("userdata", "123");
            localStorage.setItem("Limits", _res.Limits);
            localStorage.setItem("Role", _res.Role);
            localStorage.setItem("StoresHeadUrl", _res.StoresHeadUrl);
            localStorage.setItem("StoresName", _res.StoresName);
            localStorage.setItem("isAdmin", _res.isAdmin);
            localStorage.setItem("StoresType", _res.StoresType);
            localStorage.setItem("ispaiban", _res.IsPaiBan);
            localStorage.setItem("iszjyy", _res.IsZJYY);
            localStorage.setItem("hyIsPay", _res.hyIsPay);
            localStorage.setItem("spIsPay", _res.spIsPay);
            localStorage.setItem("gkIsPay", _res.gkIsPay);
            localStorage.setItem("hdIsPay", _res.hdIsPay);
            localStorage.setItem("xmIsPay", _res.xmIsPay);
            localStorage.setItem("WZHYName", _res.WZHYName);
            localStorage.setItem("WZPBName", _res.WZPBName);
            localStorage.setItem("WZXMName", _res.WZXMName);
            localStorage.setItem("WZYGName", '员工');
            localStorage.setItem("WZCDName", _res.WZCDName);
            localStorage.setItem("IsCD", _res.IsCD);
            localStorage.setItem("isshowGM", _res.isshowGM);
            localStorage.setItem("IsPBZL", _res.IsPBZL);
            localStorage.setItem("iscxjk", _res.iscxjk); 
            localStorage.setItem('zzjy',_res.ZJYYName) 
            localStorage.setItem('iscdyy',_res.iscdyy) 
            localStorage.setItem('isjifen',_res.isjifen) 
            localStorage.setItem('isyhq',_res.isyhq) 
            localStorage.setItem('isdengji',_res.isdengji) 
            localStorage.setItem('Iswyg',_res.Iswyg) 
            localStorage.setItem('isxynl',_res.isxynl) 
            localStorage.setItem('issjjhcf',_res.issjjhcf) 
            localStorage.setItem('iskczk',_res.iskczk) 
            localStorage.setItem('issfxk',_res.issfxk) 
            localStorage.setItem('iskcrs',_res.iskcrs) 
            localStorage.setItem('isYYDK',_res.isYYDK) 
            localStorage.setItem('xcxdkPhth',_res.xcxdkPhth) 
            localStorage.setItem('isweekdays',_res.isweekdays) 
            localStorage.setItem('ispaidui',_res.ispaidui) 
            localStorage.setItem('isvideo',_res.isvideo) 
            localStorage.setItem('iscdyydx',_res.iscdyydx) 
            localStorage.setItem('isqxsh',_res.isqxsh) 

             
             
            
         if (_res.DueToTimeday > 0) {    
            that.$message({
              type: "success",
              message: "登录成功",duration:2000
            });
            that.$store.commit("login", "true");
            that.$router.push({ path: "/home/home" });
         } else {
            that.$message.error("您的门店已到期，请及时续费");
         }
          } else {
            that.falseMsg = _res.Msg;
            that.showfalse = true;
          }
        },
      });
    },

    // 获取用户名密码
    getuserpwd() {
     
      if (localStorage.getItem("user") &&localStorage.getItem("pwd")) {
 
        this.ruleForm.LoginName = localStorage.getItem("user");
        this.ruleForm.Pwd = localStorage.getItem("pwd");
        this.rememberpwd = true;
    
      }
    },
    submitForm(formName) {
            
          var tokenurl = baseUrl + "/Login.aspx";
          var _parm = {
            Phone: this.ruleForm.LoginName,
            Pwd: this.ruleForm.Pwd,
          };
          var that = this;
          ajax({
            url: tokenurl,
            type: "POST",
            contentType: "application/json;",
            data: JSON.stringify(_parm),
            success: function (res) {
              let _res = JSON.parse(res);
              if (_res.orsuccess == "1") {
                  if(that.rememberpwd == true){

                      localStorage.setItem("user", that.ruleForm.LoginName);
                      localStorage.setItem("pwd", that.ruleForm.Pwd);

                    } else {

                        localStorage.removeItem("user")
                        localStorage.removeItem("pwd")
                        
                    }
                localStorage.setItem("StoresHeadUrl", _res.StoresHeadUrl);
                localStorage.setItem("StoresName", _res.StoresName);
                localStorage.setItem("DueToTimeday", _res.DueToTimeday);
                localStorage.setItem("HeadUrl", _res.HeadUrl);
                localStorage.setItem("HeadUrllogo", _res.HeadUrllogo);
                localStorage.setItem("IsActivity", _res.IsActivity);
                localStorage.setItem("IsHeadOffice", _res.IsHeadOffice);
                localStorage.setItem("IsPay", _res.IsPay);
                localStorage.setItem("IsPublic", _res.IsPublic);
                localStorage.setItem("KendTime", _res.KendTime);
                localStorage.setItem("KstartTime", _res.KstartTime);
                localStorage.setItem("LoginID", _res.LoginID);
                localStorage.setItem("Name", _res.Name);
                localStorage.setItem("Sid", _res.Sid);
                localStorage.setItem("Storemodel", _res.Storemodel);
                localStorage.setItem("isCard", _res.isCard);
                localStorage.setItem("isGoods", _res.isGoods);
                localStorage.setItem("isCashier", _res.isCashier);
                localStorage.setItem("isProject", _res.isProject);
                localStorage.setItem("isXCX", _res.isXCX);
                localStorage.setItem("token", _res.token);
                localStorage.setItem("templateType", _res.templateType);
                localStorage.setItem("StoresID", _res.StoresID);
                localStorage.setItem("Limits", _res.Limits);
                localStorage.setItem("Role", _res.Role);
                localStorage.setItem("isAdmin", _res.isAdmin);
                localStorage.setItem("isshowGM", _res.isshowGM);
                localStorage.setItem("StoresType", _res.StoresType);
                localStorage.setItem("ispaiban", _res.IsPaiBan);
                localStorage.setItem("iszjyy", _res.IsZJYY);
                localStorage.setItem("hyIsPay", _res.hyIsPay);
                localStorage.setItem("spIsPay", _res.spIsPay);
                localStorage.setItem("gkIsPay", _res.gkIsPay);
                localStorage.setItem("hdIsPay", _res.hdIsPay);
                localStorage.setItem("xmIsPay", _res.xmIsPay);
                localStorage.setItem("WZHYName", _res.WZHYName);
                localStorage.setItem("WZPBName", _res.WZPBName);
                localStorage.setItem("WZXMName", _res.WZXMName);
                localStorage.setItem("WZYGName", '员工');
                localStorage.setItem("WZCDName", _res.WZCDName);
                localStorage.setItem("IsCD", _res.IsCD);
                localStorage.setItem("IsPBZL", _res.IsPBZL);
                localStorage.setItem("iscxjk", _res.iscxjk);
                localStorage.setItem('zzjy',_res.ZJYYName)
                localStorage.setItem('iscdyy',_res.iscdyy) 
                localStorage.setItem('isjifen',_res.isjifen) 
                localStorage.setItem('isyhq',_res.isyhq) 
                localStorage.setItem('isdengji',_res.isdengji) 
                  localStorage.setItem('Iswyg',_res.Iswyg) 
                  localStorage.setItem('isxynl',_res.isxynl) 
            localStorage.setItem('issjjhcf',_res.issjjhcf) 
                        localStorage.setItem('iskczk',_res.iskczk) 
                        localStorage.setItem('issfxk',_res.issfxk) 
            localStorage.setItem('iskcrs',_res.iskcrs) 
            localStorage.setItem('isYYDK',_res.isYYDK) 
            localStorage.setItem('xcxdkPhth',_res.xcxdkPhth) 
            localStorage.setItem('isweekdays',_res.isweekdays) 
            localStorage.setItem('ispaidui',_res.ispaidui) 
            localStorage.setItem('isvideo',_res.isvideo) 
            localStorage.setItem('iscdyydx',_res.iscdyydx) 
            localStorage.setItem('isqxsh',_res.isqxsh) 
            
                if (_res.DueToTimeday > 0) {
                  that.$message({
                    type: "success",
                    message: "登录成功",duration:2000
                  });
                  localStorage.setItem("userdata", "123");
                  that.$store.commit("login", "true");
                  that.$router.push({ path: "/home/home" });
                } else {
                  that.$message.error("您的门店已到期，请及时续费");
                }
              } else if (_res.orsuccess == "2") {
                that.radio = ""
                that.show = true;
                that.list = _res.data;
                console.log(that.list);
              } else {
                that.$confirm(_res.Msg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                  }).then(() => {
                      
                  }).catch(() => {
                          
                  });
              }
            },
          });
    
    },

    //获取info列表
    // submitForm(formName) {
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       // this.logining = true
    //       // // 测试通道，不为空直接登录
    //       // setTimeout(() => {
    //       //   this.logining = false
    //       //   this.$store.commit('login', 'true')
    //       //   this.$router.push({ path: '/goods/Goods' })
    //       // }, 1000)
    //       // 注释
    //       login(this.ruleForm).then(res => {
    //         if (res.success) {
    //           if (this.rememberpwd) {
    //             //保存帐号到cookie，有效期7天
    //             setCookie('user', this.ruleForm.LoginName, 7)
    //             //保存密码到cookie，有效期7天
    //             setCookie('pwd', this.ruleForm.Pwd, 7)
    //           } else {
    //             delCookie('user')
    //             delCookie('pwd')
    //           }
    //           //如果请求成功就让他2秒跳转路由
    //           setTimeout(() => {
    //             this.logining = false
    //             // 缓存token
    //             localStorage.setItem('logintoken', res.data.token)
    //             // 缓存用户个人信息
    //             localStorage.setItem('userdata', JSON.stringify(res.data))
    //             this.$store.commit('login', 'true')
    //             this.$router.push({ path: '/home/home' })
    //           }, 1000)
    //         } else {
    //           this.$message.error(res.msg)
    //           this.logining = false
    //           return false
    //         }
    //       })
    //     } else {
    //       // 获取图形验证码
    //       // this.getcode()
    //       this.$message.error('请输入用户名密码！')
    //       this.logining = false
    //       return false
    //     }
    //   })
    // },
  },
};
</script>
<style>
.guan {
  display: flex;
  align-items: center;
}
.cursor{
  cursor:pointer !important
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
.el-menu--collapse .el-menu .el-submenu, .el-menu--popup {
    min-width: 100px!important;
}

 
.cs .el-submenu__title {
  font-size: 17px !important;
  color: black !important;
}
.cs .el-menu.el-menu--horizontal {
    border-bottom: 1px solid #ffffff  !important;
}
</style>

<style scoped>
.xiao{
  font-weight: 800;
}
.top1{
  display: flex;
   width: 1100px;
    align-items: center;
    background-color: #fff;
}
.m-tips {
  width: 100%;
  margin-left: 55%;
  float: right;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 25px;
  justify-content: space-between;
}
.m-tips .tip-item {
  font-size: 12px;
}
.el-menu-item.is-active {
  border-bottom-width: 30px;
  border-bottom: 2px solid #ffffff !important;
}
/* .label.passwordre{
    background-image: url("../assets/passwordre.svg");
} */
.input-l.current_focus {
  border-bottom-color: #007aff;
}
.loginBtn {
  position: absolute;
  bottom: 0;
  margin-bottom: 30px;
  width: 320px;
  height: 54px;
  background: rgba(0, 122, 255, 1);
  /* margin: 0 auto; */

  border-radius: 34px;
  color: #fff;
  font-size: 16px;
  line-height: 54px;
}
.label {
  width: 16px;
  height: 16px;
  background-size: cover;
  display: block;
  margin-right: 18px;
  margin-top: 6px;
}
.label.enameaccount {
  background-image: url("../assets/enameaccount.svg");
}
.label.usernameaccount {
  background-image: url("../assets/usernameaccount.svg");
}
.label.telaccount {
  background-image: url("../assets/telaccount.svg");
}

.label.password {
  background-image: url("../assets/password.svg");
}
.label.messageCode {
  background-image: url("../assets/shield.svg");
}
.label.shield {
  background-image: url("../assets/shield.svg");
}
.label.imgCode {
  background-image: url("../assets/shield.svg");
}
input {
  border: none;
  background: none !important;
  width: 270px;
  font-size: 14px;
  outline: none;
}
.input-l1 {
  padding-top: 25px;
  width: 344px;

  padding-bottom: 10px;
  margin-bottom: 13px;
  display: flex;
  justify-content: flex-start;
}

.input-l {
  padding-top: 25px;
  width: 344px;
  border-bottom: 1px #e5e5e5 solid;
  padding-bottom: 10px;
  margin-bottom: 13px;
  display: flex;
  justify-content: flex-start;
}

.flexc-cen-x1 {
  margin-top: 50px;
  margin-bottom: 40px;
  /* height: 10%; */
  width: 70%;
  display: flex;
  align-items: center;
}
.guan {
  display: flex;
  align-items: center;
}

.border {
  margin-top: 5px;
  height: 5px;
  width: 40px;
  border-radius: 100px;
  background-color: rgb(0, 132, 255);
}
.border1 {
  margin-top: 5px;
  height: 5px;
  width: 40px;
  border-radius: 100px;
  /* background-color: rgb(0, 132, 255); */
}
.nei {
  display: flex;
  align-items: center;
  width: 100%;
}
.bottom {
  margin-top: 20px;
  width: 1100px;
}
.title {
  display: flex;
  align-items: center;
  width: 100%;
}
.top {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #fff;
}
.flx {
  display: flex;
  align-items: center;
  margin-left: 40px;
}
.right {
  width: 50%;
  background-color: white;
  height: 501px;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  flex-direction: column;
}
.main {
  width: 1100px;
  display: flex;
  align-items: center;
  margin-top: 30px;
  position: relative;
  box-shadow: 0 0 73px 0 rgb(39 92 255 / 16%);
}

.app {
  width: 100%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

}

.el-menu-item {
  font-size: 17px;
  color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue